const State = function (initialState, parentState = null) {
    let stateStruct = {};
    let stateProxy = {};

    const stateChangeListeners = {};
    const stateAPI = {
        onChange (key, callback) {
            if (typeof key === 'function') {
                callback = key;
                key = '_all';
            }
            stateChangeListeners[key] = stateChangeListeners[key] || [];
            stateChangeListeners[key].push(callback);
        },

        emitChange (key, value) {
            const keyListeners = stateChangeListeners[key] || [];
            const _allListeners = stateChangeListeners._all || [];

            keyListeners.concat(_allListeners).forEach(listener => {
                listener(key, value);
            });
        },

        newSubState (initialState) {
            return State(initialState, stateAPI);
        }
    };

    Object.keys(initialState).forEach(stateKey => {
        Object.defineProperty(stateStruct, stateKey, {
            enumerable: true,
            configurable: false,
            get () {
                return stateProxy[stateKey];
            },
            set (value) {
                stateProxy[stateKey] = value;
                stateAPI.emitChange(stateKey, value);
            }
        });
        stateProxy[stateKey] = initialState[stateKey];
    });

    Object.keys(stateAPI).forEach(methodName => {
        const method = stateAPI[methodName];
        Object.defineProperty(stateStruct, methodName, {
            enumerable: false,
            configurable: false,
            value: method
        });
    });

    return stateStruct;
};

export default State;



// WEBPACK FOOTER //
// ./assets/js/core/State.js